
import cardList from "../assets/CardList";
import TarotCard from "../components/TarotCard";
import CardInfo from "../components/cards/CardData";
import EventDispatcher from "../engine/EventDispatcher";

export default class TarotCardLoader extends EventTarget {
  private tarotCards: Record<number, TarotCard>;
  private loaded: number;

  constructor() {
    super();
    this.loaded = 0;
    this.tarotCards = {};
    EventDispatcher.registerEvent("card-loader:image-loaded");
    EventDispatcher.registerEvent("card-loader:completed");
  }

  private loadImage(card: CardInfo): void {
    const image = new Image();
    image.src = card.image;
    image.onload = () => {
      this.loaded++;

      EventDispatcher.dispatch("card-loader:image-loaded");
      if (this.loaded === cardList.length) {
        EventDispatcher.dispatch("card-loader:completed");
        EventDispatcher.off("card-loader:image-loaded");
      }
    };
    
    this.tarotCards[card.id] = new TarotCard(card, image);
  }

  public load(): void {
    cardList.map((card) => this.loadImage(card));
  }

  public get cards(): Record<number, TarotCard> {
    return this.tarotCards;
  }
}